/* eslint-disable @typescript-eslint/no-explicit-any */

import { config } from '@/config';
import type {
  CallDetailResponse,
  CallTranscript,
  ConnectionDetails,
  DispatchAgentRequest,
} from '@/types/call.type';

export function mapDispatchAgentResponse(response: Record<string, any>): ConnectionDetails {
  const data = response.data;

  return {
    roomName: data.room_name,
    participantName: data.participant_name,
    participantToken: data.token,
    serverUrl: config.livekitServerUrl,
  };
}

export function mapDispatchAgentRequest(payload: DispatchAgentRequest): Record<string, any> {
  return {
    agent_id: payload.agentId,
    metadata: payload.metadata,
    participant_name: payload.participantName,
  };
}

export function mapDispatchAgentPhoneRequest(payload: DispatchAgentRequest): Record<string, any> {
  return {
    agent_id: payload.agentId,
    metadata: payload.metadata,
    phone_number: payload.phoneNumber,
    participant_name: payload.participantName,
  };
}

export function mapCallDetailResponse(payload: Record<string, any>): CallDetailResponse {
  const data = payload.data;

  return {
    id: data.id,
    callId: data.call_id,
    agentCanonicalName: data.agent_canonical_name,
    callStatus: data.call_status,
    callMode: data.call_mode,

    recordingUrl: data.recording_url,
    transcriptUrl: data.transcript_url,

    targetPhoneNumber: data.target_phone_number,
    callDuration: data.call_duration,
    summary: data.summary,
    extracted_data: data.extracted_data,
    sentiment: data.sentiment ?? null,
    createdAt: data.created_at,
  };
}

export function mapTranscriptResponse(payload: Record<string, any>): CallTranscript[] {
  const data = payload.data;

  return (
    data?.map((item: Record<string, any>) => ({
      role: item.role,
      content: item.content,
      timestamp: new Date(item.timestamp * 1000).toISOString(),
    })) || []
  );
}
